import { FormGroupName } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';

import { FormGroup } from '@angular/forms';

import { FormPackage } from '../../models/df-package';

@Component({
	selector: 'df-check-box',
	templateUrl: './check-box.component.html',
	styleUrls: ['./check-box.component.scss']
})
export class CheckBoxComponent implements OnInit {
	@Input() package: FormPackage;
	@Input() form: FormGroup;
	@Input() config: FormGroup;
	public options = [];

	constructor() {}

	ngOnInit(): void {
		this.options = this.package.options;
		if (!this.config.controls[this.package.key].value) {
			this.config.controls[this.package.key].setValue(false);
		}
	}
}
